import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Home, Search, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import owlImage from "@/assets/404-owl.png";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const isLikelyOldLink = location.pathname.includes("/pages/") || 
    location.pathname.includes("/courses/") || 
    location.pathname.includes("/collections/") ||
    location.pathname.includes("/bundles/");

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-background to-muted/50 px-4">
      {/* Die Seite antwortet mit Status 200 (Single-Page-App); noindex hält sie trotzdem aus Google heraus. */}
      <Helmet>
        <title>Seite nicht gefunden – MusiKonzept</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="mx-auto max-w-lg text-center">
        <img
          src={owlImage}
          alt="Suchende Eule mit Kopfhörern"
          className="mx-auto mb-8 h-48 w-48 drop-shadow-lg animate-[bounce_3s_ease-in-out_infinite]"
        />

        <h1 className="mb-3 text-6xl font-extrabold text-primary tracking-tight">
          Huch!
        </h1>

        <p className="mb-2 text-xl font-semibold text-foreground">
          Diese Seite gibt es hier nicht{isLikelyOldLink ? " mehr" : ""}.
        </p>

        {isLikelyOldLink ? (
          <p className="mb-8 text-muted-foreground leading-relaxed">
            Unsere Plattform hat sich verändert – und damit auch die Links! 🎶<br />
            Keine Sorge, alle Inhalte sind noch da. Entdecke unsere neue Homepage.
          </p>
        ) : (
          <p className="mb-8 text-muted-foreground leading-relaxed">
            Die Seite konnte leider nicht gefunden werden.<br />
            Vielleicht findest du über die Startseite, was du suchst.
          </p>
        )}

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button asChild size="lg" className="gap-2 px-6">
            <Link to="/">
              <Home className="h-4 w-4" />
              Zur Startseite
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="gap-2 px-6">
            <Link to="/kurse">
              <BookOpen className="h-4 w-4" />
              Kurse entdecken
            </Link>
          </Button>

          <Button asChild variant="ghost" size="lg" className="gap-2 px-6">
            <Link to="/hilfe">
              <Search className="h-4 w-4" />
              Hilfe
            </Link>
          </Button>
        </div>

        <p className="mt-10 text-xs text-muted-foreground/60">
          Fehlercode 404 · {location.pathname}
        </p>
      </div>
    </div>
  );
};

export default NotFound;
